import './DocumentLinksTable.scss';
import React, { useEffect } from 'react';
import { TableTab } from '@models/document/IDocumentScheme';
import { LinkedDocsActionsService } from '@services/actions/LinkedDocsActionsService';
import { DataGridStateService } from '@services/DataGridStateService';
import { DocumentLinksService } from '@services/DocumentLinksService';
import DevExpressDataGridDynamic from '@atoms/DevExpress/DataGrid/DevExpressDataGridDynamic';
import { useParams } from 'react-router';

export interface IDocumentLinksTableProps<TFieldValues extends object = object> {
    linkId?: string;
    linkTable: TableTab;
    docId?: string;
}

const DocumentLinksTable = <TFieldValues extends object = object>({
    linkId = undefined,
    linkTable,
    docId,
}: IDocumentLinksTableProps<TFieldValues>) => {
    const { id, actId } = useParams();
    const serviceGrid = new DocumentLinksService(docId, actId, id);
    const stateService = new DataGridStateService();
    const actionService = new LinkedDocsActionsService();
    const activated = React.useRef(false);

    useEffect(() => {
        activated.current = true;
        return () => {
            activated.current = false;
        };
    }, []);

    return (
        <div className="links-table" data-testid={linkId ? `link-table-${linkId}` : undefined}>
            <DevExpressDataGridDynamic
                key={`grid_${linkTable.key}`}
                stateService={stateService}
                dataKey={linkTable.key}
                gridKey={linkTable.key}
                linkPrefix="/document"
                service={serviceGrid}
                actionService={actionService}
                showBorders={false}
            />
        </div>
    );
};

export default DocumentLinksTable;
